export default {
  data () {
    return {
      isShowFilter: true,
      isDataPageLoading: true,
      editModal: {
        show: false,
        partnerId: null,
        form: {
          chat_id: {
            type: 'input',
            name: 'chat_id',
            label: 'Chat ID',
            placeholder: 'Chat ID',
            value: null,
            class: 'col-12'
          },
          employee1_name: {
            type: 'input',
            name: 'employee1_name',
            label: 'employee1_name',
            placeholder: 'employee1_name',
            value: null,
            class: 'col-12'
          },
          employee1_nickname: {
            type: 'input',
            name: 'employee1_nickname',
            label: 'employee1_nickname',
            placeholder: 'employee1_nickname',
            value: null,
            class: 'col-12'
          },
          employee2_name: {
            type: 'input',
            name: 'employee2_name',
            label: 'employee2_name',
            placeholder: 'employee2_name',
            value: null,
            class: 'col-12'
          },
          employee2_nickname: {
            type: 'input',
            name: 'employee2_nickname',
            label: 'employee2_nickname',
            placeholder: 'employee2_nickname',
            value: null,
            class: 'col-12'
          },
          employee3_name: {
            type: 'input',
            name: 'employee3_name',
            label: 'employee3_name',
            placeholder: 'employee3_name',
            value: null,
            class: 'col-12'
          },
          employee3_nickname: {
            type: 'input',
            name: 'employee3_nickname',
            label: 'employee3_nickname',
            placeholder: 'employee3_nickname',
            value: null,
            class: 'col-12'
          },
          tech_stack: {
            type: 'input',
            name: 'tech_stack',
            label: 'Tech Stack',
            placeholder: 'tech_stack',
            value: null,
            class: 'col-12'
          }
        }
      },
      table: {
        fields: [
          {
            key: 'partnerId',
            label: 'Partner ID'
          },
          {
            key: 'name',
            label: 'Company name',
            sortable: true
          },
          {
            key: 'chatId',
            label: 'Chat ID'
          },
          {
            key: 'employee1Name',
            label: 'employee1_name'
          },
          {
            key: 'employee1Nickname',
            label: 'employee1_nickname'
          },
          {
            key: 'employee2Name',
            label: 'employee2_name'
          },
          {
            key: 'employee2Nickname',
            label: 'employee2_nickname'
          },
          {
            key: 'employee3Name',
            label: 'employee3_name'
          },
          {
            key: 'employee3Nickname',
            label: 'employee3_nickname'
          },
          {
            key: 'techStack',
            label: 'Tech Stack'
          },
          {
            key: 'actions',
            label: 'Actions'
          }
        ],
        actions: [
          { label: 'Edit', event: 'edit', show: true },
          { label: 'Reset', event: 'remove', show: true }
        ],
        params: {
          filters: null,
          sorting: null,
          currentPage: '?page=1'
        }
      },
      filters: {
        'name': {
          type: 'input',
          name: 'name',
          label: 'Name',
          placeholder: 'Company name',
          value: null
        },
        'chat_id': {
          type: 'input',
          name: 'chat_id',
          label: 'Chat ID',
          placeholder: 'Chat ID',
          value: null
        }
      }
    }
  },
  computed: {},
  methods: {
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    showEditModal (data) {
      this.editModal.show = true
      this.editModal.partnerId = data.partnerId
      this.editModal.form.chat_id.value = data.chatId
      this.editModal.form.employee1_name.value = data.employee1Name
      this.editModal.form.employee1_nickname.value = data.employee1Nickname
      this.editModal.form.employee2_name.value = data.employee2Name
      this.editModal.form.employee2_nickname.value = data.employee2Nickname
      this.editModal.form.employee3_name.value = data.employee3Name
      this.editModal.form.employee3_nickname.value = data.employee3Nickname
      this.editModal.form.tech_stack.value = data.techStack
    },
    hideEditModal () {
      this.editModal.show = false
      this.editModal.partnerId = null
      this.editModal.form.chat_id.value = null
      this.editModal.form.employee1_name.value = null
      this.editModal.form.employee1_nickname.value = null
      this.editModal.form.employee2_name.value = null
      this.editModal.form.employee2_nickname.value = null
      this.editModal.form.employee3_name.value = null
      this.editModal.form.employee3_nickname.value = null
      this.editModal.form.tech_stack.value = null
    },
    setParamsFilters (data) {
      const filters = Object.values(data).reduce(function (state, current) {
        if (current['value']) {
          const value = typeof current['value'] === 'object'
            ? current['value'][current['valueField']] : current['value']
          state += `&filter[${current.name}]=${value}`
        }
        return state
      }, '')

      this.table.params.filters = filters || null
    },
    setParamsSort (sortDesc, sortBy) {
      if (sortBy) {
        const sortDirection = sortDesc ? 'desc' : 'asc'
        this.table.params.sorting = `&sort[${sortBy}]=${sortDirection}`
      }
    },
    setParamsCurrentPage (currentPage = 1) {
      this.table.params.currentPage = `?page=${currentPage}`
    },
    prepareDataForRequest (fields) {
      let data = {}

      for (let key in fields) {
        const field = fields[key]
        const name = field['name']
        const value = field['value']
        if (Object.prototype.toString.call(value) === '[object Array]' && value) {
          for (let valueItemKey in value) {
            const valueItemValue = value[valueItemKey]
            data[name] = data[name] ?? []
            data[name][valueItemKey] = (typeof valueItemValue === 'object' && valueItemValue && field['valueField']) ? valueItemValue[field['valueField']] : valueItemValue
          }
        } else {
          data[name] = (typeof value === 'object' && value && field['valueField']) ? value[field['valueField']] : value
        }
      }

      return data
    }
  }
}
